import {
  GET_CAMERA_FRAME,
  GET_CAMERA_FRAME_FAILURE,
  GET_CAMERA_FRAME_SUCCESS
} from '../actions/actionTypes'

import { RESET_CAMERA_FRAME } from '../actions/actionTypes'
import union from 'lodash/union'

const initialState = {
  allIds: [],
  loadingIds: {},
  byIds: {}
}

const fn = function (state = initialState, action) {
  switch (action.type) {
    case RESET_CAMERA_FRAME:
      return { ...initialState }

    case GET_CAMERA_FRAME:
      return {
        ...state,
        isLoading: true,
        loadingIds: {
          ...state.loadingIds,
          [action.id]: true
        }
      }

    case GET_CAMERA_FRAME_SUCCESS:
      return {
        ...state,
        allIds: union(state.allIds, [action.response.result]),
        byIds: Object.assign({}, state.byIds, action.response.entities.frame),
        loadingIds: {
          ...state.loadingIds,
          [action.response.result]: false
        }
      }

    case GET_CAMERA_FRAME_FAILURE:
      const newState = {
        ...state,
        allIds: state.allIds.filter((id) => action.id !== id),
        loadingIds: {
          ...state.loadingIds,
          [action.id]: false
        }
      }

      if (newState.byIds[action.id]) {
        delete newState.byIds[action.id]
      }

      return newState

    default:
      return state
  }
}
export default fn
